import { i18n } from '@/locales';
import { basicSort } from '@/utils/sort';
import { orderStatus } from './orderStatus';
const lc = 'views.list_control.thead.';
/** 라이더 정렬 로직 */
export const workerSortLogic = {
    /**
     * 배차 카운트 정렬
     */
    allocated: (a, b) => basicSort(a.allocatedCount, b.allocatedCount),
    /**
     * 픽업 카운트 정렬
     */
    pickup: (a, b) => basicSort(a.pickupCount, b.pickupCount),
    /**
     * 워커 정렬 로직
     */
    workerName: (a, b) => (String(a.user.name).localeCompare(String(b.user.name), 'ko-KR')),
};
export const sortLogic = {
    /** 상점 이름순 정렬 */
    storeName: (orderA, orderB) => (orderA.storeName.localeCompare(orderB.storeName, 'ko-KR')),
    hubName: (orderA, orderB) => (String(orderA.hubName).localeCompare(String(orderB.hubName), 'ko-KR')),
    todayNumber: (orderA, orderB) => basicSort(orderA.todayNumber, orderB.todayNumber),
    orderId: (orderA, orderB) => (String(orderA.orderId).localeCompare(String(orderB.orderId), 'ko-KR')),
    distanceKilometer: (orderA, orderB) => basicSort(orderA.distanceKilometer, orderB.distanceKilometer),
};
export const tableHeaders = [
    /** 공유 상태 */
    {
        title: '',
        value: 'isShare',
        width: 8,
    },
    /** 상태 */
    {
        title: i18n.t(`${lc}state`),
        align: 'center',
        value: '',
        width: 60,
    },
    /** 주의사항 */
    {
        title: i18n.t(`${lc}caution`),
        align: 'center',
        value: '',
        width: 100,
    },
    /** 당일순번 */
    {
        title: '당일순번',
        align: 'center',
        value: 'todayNumber',
        width: 100,
        sortable: true,
    },
    /** 발주허브명 */
    {
        title: '발주허브',
        align: 'center',
        value: 'hubName',
        width: 200,
        sortable: true,
    },
    /** 발주상점 */
    {
        title: '발주상점',
        align: 'center',
        value: 'storeName',
        width: 200,
        sortable: true,
    },
    /** 상점 전화번호 */
    {
        title: '상점 전화번호',
        align: 'center',
        value: 'storePhone',
        width: 170,
    },
    /** 고객번호1 */
    {
        title: '고객번호1',
        align: 'center',
        value: 'receiverPhone',
        width: 170,
    },
    /** 담당 라이더 */
    {
        title: i18n.t(`${lc}allocated_worker`),
        align: 'center',
        value: 'allocatedWorkerName',
        width: 170,
    },
    /** 라이더 전화번호 */
    {
        title: '라이더 전화번호',
        align: 'center',
        value: 'allocatedWorkerPhone',
        width: 170,
    },
    /** 배차라이더총판 */
    {
        title: '배차라이더총판',
        align: 'center',
        value: 'allocatedDistributorId',
        width: 170,
    },
    /** 배차라이더허브 */
    {
        title: '배차라이더허브',
        align: 'center',
        value: 'allocatedHubName',
        width: 170,
    },
    /** 출발지 주소 */
    {
        title: i18n.t(`${lc}pickup_address`),
        align: 'center',
        value: 'orderPickupAddress',
        width: 450,
    },
    /** 출발지 메모 */
    {
        title: i18n.t(`${lc}pickup_memo`),
        align: 'center',
        value: 'pickupAddressMemo',
        width: 300,
    },
    /** 도착지 주소 */
    {
        title: i18n.t(`${lc}drop_address`),
        align: 'center',
        value: 'orderDropAddress',
        width: 450,
    },
    /** 특이사항 */
    {
        title: '특이사항',
        align: 'center',
        value: 'memo',
        width: 350,
    },
    /** 주문상품 */
    {
        title: '주문상품',
        align: 'center',
        value: '',
        width: 170,
    },
    /** 상품상태 */
    {
        title: '상품상태',
        align: 'center',
        value: '',
        width: 170,
    },
    /** 준비상태 */
    {
        title: '준비상태',
        align: 'center',
        value: '',
        width: 170,
    },
    /** 경과시간 */
    {
        title: '경과시간',
        align: 'center',
        value: '',
        width: 100,
    },
    /** 접수시간 */
    {
        title: '접수시간',
        align: 'center',
        value: '',
        width: 100,
    },
    /** 배차시간 */
    {
        title: '배차시간',
        align: 'center',
        value: '',
        width: 100,
    },
    /** 픽업시간 */
    {
        title: '픽업시간',
        align: 'center',
        value: '',
        width: 100,
    },
    /** 픽업 예상시간 */
    {
        title: i18n.t(`${lc}pickup_expected_at`),
        align: 'center',
        value: '',
        width: 100,
    },
    /** 완료시간 */
    {
        title: '완료시간',
        align: 'center',
        value: '',
        width: 100,
    },
    /** 예약시간 */
    {
        title: '예약시간',
        align: 'center',
        value: '',
        width: 100,
    },
    /** 상품 금액 */
    {
        title: i18n.t(`${lc}goods_amount`),
        align: 'center',
        value: '',
        width: 110,
    },
    /** 패널티누적액 */
    {
        title: '패널티누적액',
        align: 'center',
        value: '',
        width: 110,
    },
    /** 배달대행료 */
    {
        title: '배달대행료',
        align: 'center',
        value: '',
        width: 110,
    },
    /** 라이더지원금 */
    {
        title: '라이더지원금',
        align: 'center',
        value: '',
        width: 110,
    },
    /** 프로모션지원금 */
    {
        title: i18n.t(`${lc}promotion_charge`),
        align: 'center',
        value: '',
        width: 120,
    },
    /** 상품할증료 */
    {
        title: '상품할증료',
        align: 'center',
        value: '',
        width: 110,
    },
    /** 대행료합계 */
    {
        title: '대행료합계',
        align: 'center',
        value: '',
        width: 110,
    },
    /** 결제방법 */
    {
        title: i18n.t(`${lc}pay_type`),
        align: 'center',
        value: '',
        width: 80,
    },
    /** 현금 */
    {
        title: '현금',
        align: 'center',
        value: '',
        width: 110,
    },
    /** 카드 */
    {
        title: '카드',
        align: 'center',
        value: '',
        width: 110,
    },
    /** 선결제 */
    {
        title: '선결제',
        align: 'center',
        value: '',
        width: 110,
    },
    /** 비과세(보증금) */
    {
        title: '비과세(보증금)',
        align: 'center',
        value: '',
        width: 110,
    },
    /** 카드승인 */
    {
        title: '카드승인',
        align: 'center',
        value: '',
        width: 90,
    },
    /** 카드승인번호 */
    {
        title: '카드승인번호',
        align: 'center',
        value: '',
        width: 170,
    },
    /** 카드사 */
    {
        title: '카드사',
        align: 'center',
        value: '',
        width: 90,
    },
    /** 할부개월 */
    {
        title: '할부개월',
        align: 'center',
        value: '',
        width: 90,
    },
    /** 주소기반배달정보 */
    {
        title: '주소기반배달정보',
        align: 'center',
        value: '',
        width: 170,
    },
    /** 주문제휴사배달아이디 */
    {
        title: '주문제휴사배달아이디',
        align: 'center',
        value: '',
        width: 170,
    },
    /** 주류 */
    // 주의사항에 있음
    // {
    //   title: '주류',
    //   align: 'center',
    //   value: '',
    //   width: 170,
    // },
    /** 취소메모 */
    {
        title: '취소메모',
        align: 'center',
        value: '',
        width: 170,
    },
    /** 배차취소 패널티 횟수 */
    {
        title: '배차취소 패널티 횟수',
        align: 'center',
        value: 'allocatedCancelPenaltyCount',
        width: 150,
    },
    /** 라이더에게 지불 방식 */
    {
        title: '라이더에게 지불 방식',
        align: 'center',
        value: '',
        width: 150,
    },
    /** 상담원 */
    {
        title: '상담원',
        align: 'center',
        value: '',
        width: 90,
    },
    /** 접수번호 */
    {
        title: '접수번호',
        align: 'center',
        value: 'orderId',
        width: 130,
        sortable: true,
        headerProps: {
            class: 'cy-th-order-id',
        },
    },
    /** 운행거리 */
    {
        title: i18n.t(`${lc}distance`),
        align: 'center',
        value: 'distanceKilometer',
        width: 100,
        sortable: true,
    },
];
/**
 * 목록관제에서 관리하는 상태들
 * 목록관제 주문 필터 or 카운트 종류 부분
 * */
export const orderStatusGroupList = {
    /** 전체 */
    ALL: orderStatus.ALL,
    /** 접수 필터 */
    ACCEPTED: orderStatus.ACCEPTED,
    /** 배차 필터 */
    ALLOCATED: orderStatus.ALLOCATED,
    /** 픽업 필터 */
    PICKUP: orderStatus.PICKUP,
    /** 자체 필터 */
    SELF: orderStatus.SELF,
    /** 완료 필터 */
    DROP_FINISHED: orderStatus.DROP_FINISHED,
    /** 취소 필터 */
    CANCELED: orderStatus.CANCELED,
};
/**
 * 주문의 orderStatus가 현재 필터 리스트에 포함되는지 여부 판단
 * 예를 들면 배차요청은 상태는 배차 필터에서 보여져야 한다.
 * 픽업 도착은 아직은 배차 필터에 보여져야 한다 등등을 분리
 *
 * 배차 취소 => 접수 필터에서 보여야 함
 */
export const orderStatusGroup = {
    // 접수
    [orderStatus.ALLOCATE_CANCEL.code]: orderStatus.ACCEPTED.code,
    [orderStatus.RESERVED.code]: orderStatus.ACCEPTED.code,
    [orderStatus.RESERVE_END.code]: orderStatus.ACCEPTED.code,
    [orderStatus.ACCEPTED.code]: orderStatus.ACCEPTED.code,
    [orderStatus.WORKER_REQUESTED.code]: orderStatus.ACCEPTED.code,
    [orderStatus.RE_ACCEPT.code]: orderStatus.ACCEPTED.code,
    [orderStatus.ALLOCATE_REJECTED.code]: orderStatus.ACCEPTED.code,
    [orderStatus.PRIORITY_ALLOCATE_CANCEL.code]: orderStatus.ALLOCATED.code,
    // 배차
    [orderStatus.PRIORITY_ALLOCATE.code]: orderStatus.ALLOCATED.code,
    [orderStatus.IMMEDIATE_ALLOCATE.code]: orderStatus.ALLOCATED.code,
    [orderStatus.ALLOCATED.code]: orderStatus.ALLOCATED.code,
    [orderStatus.PICKUP_ARRIVED.code]: orderStatus.ALLOCATED.code,
    [orderStatus.WORKER_REQUESTED_CANCEL.code]: orderStatus.ALLOCATED.code,
    // 픽업
    [orderStatus.PICKUP.code]: orderStatus.PICKUP.code,
    [orderStatus.PICKUP_FINISHED.code]: orderStatus.PICKUP.code,
    // 자체
    [orderStatus.SELF.code]: orderStatus.SELF.code,
    [orderStatus.SELF_DELIVERY.code]: orderStatus.SELF.code,
    [orderStatus.SELF_DELIVERING.code]: orderStatus.SELF.code,
    // 완료
    [orderStatus.DROP_FINISHED.code]: orderStatus.DROP_FINISHED.code,
    [orderStatus.SELF_DROP_FINISHED.code]: orderStatus.DROP_FINISHED.code,
    // 취소
    [orderStatus.CANCELED.code]: orderStatus.CANCELED.code,
    // 이하 확인 필요
    [orderStatus.ORDER.code]: orderStatus.ORDER.code,
    [orderStatus.ORDER_REJECT.code]: orderStatus.ORDER_REJECT.code,
    [orderStatus.ORDER_MODIFY.code]: orderStatus.ORDER_MODIFY.code,
    [orderStatus.ALL.code]: orderStatus.ALL.code,
    [orderStatus.NONE.code]: orderStatus.NONE.code,
    [orderStatus.QUESTION.code]: orderStatus.QUESTION.code,
    [orderStatus.SETTLED.code]: orderStatus.SETTLED.code,
    [orderStatus.WAITED.code]: orderStatus.WAITED.code,
    [orderStatus.WAIT_END.code]: orderStatus.WAIT_END.code,
};
/** 검색어 셀렉트 */
export const searchFieldOptionList = [
    {
        text: '당일순번',
        value: 'todayNumber',
    },
    {
        text: '상담원ID',
        value: 'createdBy',
    },
    {
        text: '접수번호',
        value: 'orderId',
    },
    {
        text: '특이사항',
        value: 'memo',
    },
    {
        text: '발주허브',
        value: 'hubName',
    },
    {
        text: '상점이름',
        value: 'storeName',
    },
    {
        text: '배차라이더',
        value: 'allocatedWorkerName',
    },
    {
        text: '라이더 연락처',
        value: 'allocatedWorkerPhone',
    },
];
